export const TILE_SIZE_RESPONSIVE = 50;
export const TILE_SIZE = 100;
export const OPACITY_GRID_EVENT = 0.2;
export const INITIAL_RADIUS_THEME = 2;
export const GAME_CONTEST_DURATION = [30, 60, 90, 120];
export const scaleMarks = [
  {
    value: 0.5,
    label: "0.5",
  },
  {
    value: 1,
    label: "1",
  },
  {
    value: 1.5,
    label: "1.5",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 2.5,
    label: "2.5",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 3.5,
    label: "3.5",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 4.5,
    label: "4.5",
  },
  {
    value: 5,
    label: "5",
  },
];
export const radiusMarks = [
  {
    value: 0.5,
    label: "0.5",
  },
  {
    value: 1,
    label: "1",
  },
  {
    value: 1.5,
    label: "1.5",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 2.5,
    label: "2.5",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 3.5,
    label: "3.5",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 4.5,
    label: "4.5",
  },
  {
    value: 5,
    label: "5",
  },
];
export const rotationMarks = [
  {
    value: 0,
    label: "0°",
  },
  {
    value: 90,
    label: "90°",
  },
  {
    value: 180,
    label: "180°",
  },
  {
    value: 270,
    label: "270°",
  },
];
export const themeFilters = (t) => {
  return [
    {
      value: "blackAndWhite",
      title: t("myExpariences.form.blackAndWhite"),
    },
    {
      value: "sepia",
      title: t("myExpariences.form.sepia"),
    },
    {
      value: "rainy",
      title: t("myExpariences.form.rainy"),
    },
  ];
};
export const allThemes = [
  "songAndFilter",
  "song",
  "sepia",
  "blackAndWhite",
  "rainy",
];
export const allEvents = ["fw1", "fw2", "smoke"];

export const presetFormats = {
  XP7: [
    {
      column: "6",
      rotation: "east",
      row: "5",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      column: "6",
      rotation: "east",
      row: "6",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      column: "6",
      rotation: "east",
      row: "7",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      column: "4",
      rotation: "west",
      row: "5",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      column: "4",
      rotation: "west",
      row: "6",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      column: "4",
      rotation: "west",
      row: "7",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      column: "4",
      rotation: "north",
      row: "4",
      type: "frame",
      molding: "oak",
      size: "medium",
    },
    {
      startTile: { row: 4, column: 5 },
      endTile: { row: 4, column: 6 },
      rotation: "north",
      type: "ipad",
      autoplay: false,
      mainVideo: false,
      link: "",
      links: [],
      mute: false,
      live: false,
      start: null,
      end: null,
    },
    {
      row: "8",
      column: "5",
      type: "spawn",
      rotation: "north",
    },
  ],
  XPFrame: [
    {
      column: "5",
      rotation: "north",
      row: "4",
      type: "frame",
      size: "medium",
    },
    {
      row: "6",
      column: "5",
      type: "spawn",
      rotation: "north",
      size: "medium",
    },
  ],
  XP1: [
    {
      column: "4",
      rotation: "north",
      row: "4",
      type: "frame",
      size: "medium",
    },
    {
      startTile: { row: 4, column: 5 },
      endTile: { row: 4, column: 6 },
      rotation: "north",
      type: "ipad",
      autoplay: false,
      mainVideo: false,
      link: "",
      links: [],
      mute: false,
      live: false,
      start: null,
      end: null,
    },
    {
      row: "6",
      column: "5",
      type: "spawn",
      rotation: "north",
    },
  ],
};
